import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD'
  }).format(amount);
}

export function formatDate(dateString) {
  if (!dateString) return '';
  // Parse as local date to avoid timezone offset issues
  const parts = dateString.split('-');
  if (parts.length === 3) {
    const date = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
    return date.toLocaleDateString('en-AU', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }
  return new Date(dateString).toLocaleDateString('en-AU', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

export const statusColors = {
  draft: 'status-draft',
  pending: 'status-pending',
  pending_approval: 'status-pending',
  confirmed: 'status-confirmed',
  production: 'status-production',
  invoiced: 'status-invoiced',
  paid: 'status-paid',
  completed: 'status-completed',
  cancelled: 'status-cancelled'
};

export const productTypes = [
  { value: 'full_page', label: 'Full Page', size: '1/1' },
  { value: 'half_page', label: 'Half Page', size: '1/2' },
  { value: 'quarter_page', label: 'Quarter Page', size: '1/4' },
  { value: 'eighth_page', label: 'Eighth Page', size: '1/8' },
  { value: 'sponsored_content', label: 'Sponsored Content', size: 'custom' }
];

export const positions = [
  { value: 'top', label: 'Top' },
  { value: 'bottom', label: 'Bottom' },
  { value: 'left', label: 'Left' },
  { value: 'right', label: 'Right' },
  { value: 'full', label: 'Full Page' }
];
